import React, { lazy, Suspense, useState } from 'react';
import { MessageCircleIcon, BotIcon, CheckCircleIcon } from 'lucide-react';
const AIChatModal = lazy(() => import('../modals/AIChatModal').then(module => ({
  default: module.AIChatModal
})));
export function PharmacistChat() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  return <>
      {/* Chat Button - Updated mobile positioning */}
      <button onClick={() => setIsChatOpen(true)} className="fixed bottom-44 md:bottom-20 right-4 md:right-6 bg-gradient-to-r from-[#1E2B55] to-[#2a3a6f] text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all z-40 group" aria-label="Chat with Pharmacist" data-id="element-5224" data-mp="27fh6d0hx7zkj">
        <BotIcon className="w-7 h-7" data-id="element-5225" data-mp="2m3u4o44hdui7" />
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-blue-500 rounded-full animate-pulse" data-id="element-5226" data-mp="2m2smlfp1s7qz"></span>
        {/* Tooltip */}
        <div className="absolute left-full ml-3 top-1/2 transform -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-5227" data-mp="2r13wfqfcei97">
          <div className="font-medium" data-id="element-5228" data-mp="mer5ag6tdae4">AI Pharmacist Chat</div>
          <div className="text-xs text-gray-300 flex items-center mt-1" data-id="element-5229" data-mp="md6bwtw8jxhu">
            <CheckCircleIcon className="w-3 h-3 mr-1" data-id="element-5230" data-mp="hg64aejqmmom" />
            Powered by AI • 24/7
          </div>
          <div className="absolute top-1/2 -left-1 transform -translate-y-1/2 w-2 h-2 bg-gray-900 rotate-45" data-id="element-5231" data-mp="chldf5qdlfcu"></div>
        </div>
      </button>
      {isChatOpen && <Suspense fallback={null} data-id="element-5232" data-mp="1558w2f835vwu"><AIChatModal isOpen onClose={() => setIsChatOpen(false)} data-id="element-5233" data-mp="154pfb1u69dke" /></Suspense>}
    </>;
}